<template>
  <div class="single-choice">
    <!--答题区小题编号-->
    <div
      class="toolbar clearfix"
      v-if="currentQuestion.quesTypeID !== 4 && currentQuestion.quesTypeID !== 5"
    >
      <div class="more fl">
        <span @click="runCalc"><i class="icon-cal" />计算器</span>
      </div>
      <div class="ques-tit fr">
        <label><input
            type="checkbox"
            :checked="currentQuestion.isMark"
            :value="1"
            @click="markToggleFn"
          />
          标记本题</label>
      </div>
    </div>
    <div class="content-stem"><span>{{ currentQuestion.showSerialNum }}、</span>
      <span v-html="currentQuestion.content" />
    </div>
    <div class="content-list">
      <div
        class="content-option"
        v-for="(option, index) in currentQuestion.optionList"
        :key="index"
      >
        <label>
          <input
            type="radio"
            name="singleQuestion"
            :value="option.quesValue"
            :checked="hasAns(option.quesValue)"
            @click="radioToggleFn"
          >
          <strong>{{ option.quesValue }}.&nbsp;</strong>
          <span v-html="option.quesOption" />
        </label>
      </div>
      <div v-if="$route.query.flag === 'ordinary'">
        <div
          class="color-common left-score"
          v-if="isShowProposal"
        >
          【本题 {{currentQuestion.score}} 分，建议 {{currentQuestion.limitMinute/60}} 分钟内完成本题】
        </div>
        <div class="color-common right-btns clearfix">
          <a
            href="javascript:void(0)"
            class="fr collect-btn"
            v-if="isShowCollect"
            @click="collectQues(currentQuestion.questionID, currentQuestion.chapterID)"
          >【加入题库收藏夹】</a>
          <a
            href="javascript:void(0)"
            class="fr video-btn"
            @click="videoExplain(currentQuestion.questionID,currentQuestion.pointList)"
            v-if="isShowVideoExplain && currentQuestion.vdeioAddr !== null && currentQuestion.vdeioAddr !== ''"
          >【查看视频讲解】</a>
          <a
            class="fr"
            :href="faqlUrl + currentQuestion.questionID"
            target="_blank"
            v-if="isShowAnswerQuestion"
          >【答疑编号{{currentQuestion.questionID}}，点击提问】</a>
        </div>
        <div
          class="color-common questions-location"
          v-if="isShowQzSeat"
        >
          <span class="fr">【题目位置：{{currentQuestion.bookName}}--{{currentQuestion.chapterName}}--第{{currentQuestion.pageNum}}页--第{{currentQuestion.quesNum}}题】</span>
        </div>
        <div
          class="color-common is-show-answers"
          @click="toggleAnalyse"
          v-if="isShowAnswer"
          v-text="isAnswerShowNew === true ? '【隐藏答案】': '【显示答案】'"
        >
        </div>
        <div
          class="answer-box"
          v-if="isAnswerShowNew"
        >
          【<strong class="answer-right">正确答案</strong>】
          <span v-html="currentQuestion.answer"></span><br />
          【<strong class="answer-ananlysis">答案解析</strong>】
          <span v-html="currentQuestion.analysis"></span><br />
          <span
            class="answer-assessment"
            v-if="isShowPointAssessment"
          >【该题针对 <span
              class="answer-assessment-name"
              v-html="'“'+currentQuestion.pointNames+'”'"
            ></span> 进行考核】</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getCookie } from '@/utils'
import { addFavoriteQues, getPlayAuxiliaryUrl } from '@/api'

export default {
  name: 'ExamSingleChoice',
  props: {
    isShowProposal: {
      //是否显示建议
      type: Boolean,
      default: false
    },
    isShowAnswerQuestion: {
      //是否显示答疑
      type: Boolean,
      default: false
    },
    isShowAnswer: {
      //是否显示答案项
      type: Boolean,
      default: false
    },
    isAnswerShow: {
      //是否显示答案
      type: Boolean,
      default: false
    },
    isShowQzSeat: {
      //是否显示题目位置
      type: Boolean,
      default: false
    },
    isShowCollect: {
      //是否显示收藏
      type: Boolean,
      default: false
    },
    isShowPointAssessment: {
      //是否显示知识点考核
      type: Boolean,
      default: false
    },
    isShowVideoExplain: {
      //是否显示视频讲解
      type: Boolean,
      default: false
    },
    faqlUrl: {
      //答疑跳转地址
      type: String
    }
  },
  data() {
    return {
      isAnswerShowNew: this.isAnswerShow
    }
  },
  watch: {
    isAnswerShow() {
      this.isAnswerShowNew = false
    }
  },
  mounted() {
    this.isAnswerShowNew = false
  },
  computed: {
    ...mapGetters(['currentQuestion', 'currentQuestionIndex'])
  },
  methods: {
    hasAns(old) {
      let userAns = this.currentQuestion.userAnswer
      let flag = false
      if (userAns && userAns === old) {
        flag = true
      }
      return flag
    },
    radioToggleFn(e) {
      this.$nextTick(() => {
        let value =
          this.currentQuestion.userAnswer === e.target.value
            ? ''
            : e.target.value
        let isAnswer = value ? 1 : 0
        this.$store.dispatch('setUserAns', value)
        this.$store.dispatch('setIsAns', isAnswer)
      })
    },
    // 标记本题
    markToggleFn() {
      this.$emit('markToggleFn')
    },
    runCalc() {
      this.$emit('runCalc')
    },
    toggleAnalyse() {
      this.isAnswerShowNew = !this.isAnswerShowNew
    },
    //加入题库收藏夹
    async collectQues(questionID, chapterID, parentID) {
      const questionIDParam = parentID ? parentID : questionID
      let collectQuesParams = {
        flag: 'ordinary',
        courseID: parseInt(this.$route.query.courseID),
        userID: parseInt(getCookie('cdeluid')),
        questionID: questionIDParam,
        chapterID
      }
      await addFavoriteQues(collectQuesParams).then(() => {
        this.$message({
          showClose: true,
          message: '题目收藏成功！',
          type: 'success'
        })
      })
    },
    //视频讲解
    videoExplain(questionID, pointList) {
      let pointIDArr = [],
        pointIDStr = ''
      for (let i in pointList) {
        if (pointList[i] && pointList[i].pointID) {
          pointIDArr.push(pointList[i].pointID)
        }
      }
      pointIDStr = pointIDArr.join(',')
      let params = {
        questionId: String(questionID),
        pointList: pointIDStr
      }
      getPlayAuxiliaryUrl(params).then(res => {
        window.open(res.playUrl, '_blank')
      })
    }
  }
}
</script>
